import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const RecordTabs = ({ activeTab, onTabChange, tabCounts }) => {
  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'User', count: null },
    { id: 'consultations', label: 'Consultations', icon: 'Calendar', count: tabCounts?.consultations },
    { id: 'lab-results', label: 'Lab Results', icon: 'FileText', count: tabCounts?.labResults },
    { id: 'prescriptions', label: 'Prescriptions', icon: 'Pill', count: tabCounts?.prescriptions },
    { id: 'credentials', label: 'Credentials', icon: 'Shield', count: tabCounts?.credentials },
    { id: 'documents', label: 'Documents', icon: 'FolderOpen', count: tabCounts?.documents }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-clinical">
      {/* Desktop Tabs */}
      <div className="hidden md:flex border-b border-border">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-6 py-4 text-sm font-medium border-b-2 transition-clinical ${
              activeTab === tab?.id
                ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
            }`}
          >
            <Icon name={tab?.icon} size={16} />
            <span>{tab?.label}</span>
            {tab?.count !== null && (
              <span className={`ml-1 px-2 py-0.5 text-xs rounded-full ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {tab?.count}
              </span>
            )}
          </button>
        ))}
      </div>
      {/* Mobile Tab Selector */}
      <div className="md:hidden p-4 border-b border-border">
        <div className="relative">
          <select
            value={activeTab}
            onChange={(e) => onTabChange(e?.target?.value)}
            className="w-full appearance-none bg-input border border-border rounded-md px-4 py-2 pr-8 text-sm font-medium text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          >
            {tabs?.map((tab) => (
              <option key={tab?.id} value={tab?.id}>
                {tab?.label} {tab?.count !== null ? `(${tab?.count})` : ''}
              </option>
            ))}
          </select>
          <Icon 
            name="ChevronDown" 
            size={16} 
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none" 
          />
        </div>
      </div>
    </div>
  );
};

export default RecordTabs;